import { TrendingUp, TrendingDown } from 'lucide-react';
import styles from './StatCard.module.css';

/** KPI stat card with optional delta. Used on the overview dashboard (Phase 7 fills
 *  these with live metrics; Phase 0 shows the layout). */
export function StatCard({ label, value, delta, icon: Icon, tone = 'default' }) {
  const up = typeof delta === 'number' && delta >= 0;
  return (
    <div className={`${styles.card} ${styles[tone]}`}>
      <div className={styles.top}>
        <span className={styles.label}>{label}</span>
        {Icon && (
          <span className={styles.icon}>
            <Icon size={18} />
          </span>
        )}
      </div>
      <div className={`${styles.value} mono`}>{value}</div>
      {typeof delta === 'number' && (
        <div className={`${styles.delta} ${up ? styles.up : styles.down}`}>
          {up ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
          <span>{Math.abs(delta)}% vs last month</span>
        </div>
      )}
    </div>
  );
}

export default StatCard;
